import { Injectable } from '@angular/core';
import { SingleDepartmentService } from '../../../shared/services/single-department.service';

@Injectable({
  providedIn: 'root',
})
export class PolyurethaneDepartmentService extends SingleDepartmentService {
  override readonly NAME = 'Polyurethane';
  override readonly BRAND = 'daystar';

  private _departmentId: number;

  set departmentId(value: number) {
    this._departmentId = value;
  }

  get departmentId(): number {
    return this._departmentId;
  }

  defaultRoutes(roles: string[]): boolean {
    if (
      roles.includes('PolyurethaneViewer') ||
      roles.includes('PolyurethaneOperator') ||
      roles.includes('PolyurethaneLeader') ||
      roles.includes('PolyurethaneSupervisor') ||
      roles.includes('PolyurethaneAdmin') ||
      roles.includes('PolyurethaneChief')
    ) {
      this.router.navigate(['/sb/polyurethane/scheduler']);
      return true;
    }
    if (roles.includes('PolyurethaneLabel')) {
      this.router.navigate(['/sb/polyurethane/packing-box']);
      return true;
    }
    if (roles.includes('PolyurethaneQc')) {
      this.router.navigate(['/sb/polyurethane/quality-control/visual']);
    }
    return false;
  }
}
